export const URL_GET_REWARD_LIST = "/v1/gocheckin/reward/site/list?";
export const URL_GET_REWARD_HISTORY_LIST = "/v1/gocheckin/reward/site/history?";
export const URL_ADD_REWARD = "/v1/gocheckin/reward/form/create";
export const URL_UPDATE_REWARD = "/v1/gocheckin/reward/form/update?";
export const URL_DELETE_REWARD = "/v1/gocheckin/reward/form/delete?";
export const URL_EXPORT_REWARD_HISTORY = "/v1/gocheckin/reward/site/export-history";